import { render, staticRenderFns } from "./jenisiklan.vue?vue&type=template&id=0d9fbadd"
import script from "./jenisiklan.vue?vue&type=script&lang=js"
export * from "./jenisiklan.vue?vue&type=script&lang=js"
import style0 from "./jenisiklan.vue?vue&type=style&index=0&id=0d9fbadd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports